"use client"

function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
        <div
            className={`${className} custom-arrow custom-next-arrow`}
            style={{ ...style, display: "block" }}
            onClick={onClick}
        >
            <i className="fas fa-chevron-right"></i>
        </div>
    )
}

export default SampleNextArrow
